// @dynamic
export class KnownBusyScopes {
  public static get presenter(): { header: string } {
    return { header: 'presenterHeaderScope' };
  }
}
